import React from "react";
import { constructCurrency, convertAmountToCents } from "common/currency";
import { useFiatCurrency } from "hooks/firestore/user/useFiatCurrency";

type PayoutValueProps = {
  dollars: number;
  tbd?: boolean;
  testId?: string;
};

export const PayoutValue = ({ dollars, tbd, testId }: PayoutValueProps) => {
  const currency = useFiatCurrency();

  return (
    <span data-testid={testId}>
      {tbd
        ? "TBD"
        : constructCurrency(convertAmountToCents(dollars), {
            currencyType: currency,
            roundDown: true,
          })}
    </span>
  );
};
